<template>
  <div class="page-content">
    <PageTitle :main="$t('fechamento-do-dia-de-producao')" sub imagem="Planejamento.png" />
    <div class="container">
      <!-- DATA E UNIDADE -->
      <div class="row mb-3 occurrence-date">
        <div class="col-6 date-item d-flex">
          <label class="mr-3" for="date-picker">{{ $t('data-de-fechamento') }}</label>
          <date-picker
            id="date-picker"
            class="adjustDatePickers"
            ref="datePickerStart"
            name="date"
            v-model="productionDate"
            :config="optionsDatePicker"
            autocomplete="off"
          ></date-picker>
          <i class="fa fa-calendar fa-lg ml-2" aria-hidden="true"></i>
        </div>

        <div class="col-6 unit-production-config">
          <label for="unit-production">{{ $t('unidade-de-producao') }}</label>
          <select
            class="form-control"
            id="unit-production"
            @change="setProductionUnit"
          >
            <option default>{{ $t('selecione-uma-unidade') }}</option>
            <option
              v-for="unit in this.productionsUnitList"
              :key="unit.id"
              :value="unit.initials"
              >{{ unit.name }}</option
            >
          </select>
          <div class="seachButtonGroup">
            <img
              v-if="!loadingReport"
              @click="this.loadOccurrenceConfig"
              id="search-button"
              src="../../assets/buscar.png"
              :title="$t('pesquisar-0')"
              :alt="$t('buscar_indicadores')"
            />
            <span
              v-else
              class="spinner-border spinner-border-sm spinnerConfig"
              role="status"
              aria-hidden="true"
            ></span> 
          </div>  
        </div>
      </div>
      <!-- / DATA E UNIDADE -->

      <!-- SELECIONE UM INDICADOR -->
      <section v-if="showForm">
        <div class="row">
          <div
            class="col-12 table-responsive-md table-wrapper-scroll-y my-custom-scrollbar"
          >
            <div class="title-filter">
              <p class="h6">{{ $t('selecione-um-indicador-fora-da-especificacao') }}</p>
              <div id="filter-box" class="ml-2">
                <label class="">{{ $t('filtro') }}</label>
                <input class="ml-1 mb-1 input-pentagro" v-model="filter" />
              </div>
            </div>

            <table class="table table-hover table-striped">
              <thead class="thead-dark">
                <th scope="col">{{ $t('indicador-0') }}</th>
                <th class="text-center" scope="col">{{ $t('real-0') }}</th>
                <th class="text-center" scope="col">{{ $t('previsto-0') }}</th>
                <th class="text-center" scope="col">{{ $t('aderencia-0') }}</th>
                <th class="text-center" scope="col">{{ $t('peso') }}</th>
                <th class="text-center" scope="col">{{ $t('ocorrencias') }}</th>
              </thead>
              <tbody>
                <template v-if="this.filteredIndicators.length != 0">
                  <tr
                    :class="`indicator-${indicator.id}`"
                    v-for="indicator in this.filteredIndicators"
                    :key="indicator.id"
                    @dblclick="setSelectedIndicator"
                  >
                    <td>{{ indicator.name }}</td>
                    <td class="text-center">
                      {{ ParseNumber(indicator.value) }}
                    </td>
                    <td class="text-center">
                      {{ ParseNumber(indicator.target) }}
                    </td>
                    <td class="text-center">{{ indicator.reliability }}</td>
                    <td class="text-center">{{ indicator.weight }}</td>
                    <td class="text-center">{{ indicator.occurrences }}</td>
                  </tr>
                </template>
                <tr v-else>
                  <td colspan="6">{{ $t('sem-dados-na-data-e-unidade-indicadas') }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </section>
      <!-- /SELECIONE UM INDICADOR -->

      <!-- OCORRENCIAS -->
      <span v-if="indicatorId">
        <!-- CRIAR OCORRENCIAS -->
        <section class="mt-3">
          <div class="mb-3">
            <p class="h6">{{ $t('inserir-ocorrencia') }}</p>
          </div>

          <div class="occurrence-insertion">
            <div class="responsible-config">
              <div class="responsible-list">
                <label for="responsible-select"
                  >{{ $t('responsavel-pela-ocorrencia') }}</label
                >
                <select
                  class="form-control"
                  id="responsible-select"
                  @change="setResponsible"
                  v-model="responsibleKey"
                >
                  <option value="null" selected>{{ $t('selecione-um-responsavel') }}</option>
                  <template v-if="this.responsibleList">
                    <option
                      v-for="resp in this.responsibleList"
                      :key="`${resp.id}-${resp.unitId}-${resp.system}`"
                      :value="`${resp.id}-${resp.unitId}-${resp.system}`"
                      >{{ resp.name }}</option
                    >
                  </template>
                </select>
              </div>

              <div class="row-flex mt-3">
                <span class="row-flex">
                  <label class="mr-5">{{ $t('motivo-0') }}</label>
                  <textarea
                    disabled
                    name="ocurrence"
                    :placeholder="$t('clique-no-botao-para-selecionar-um-motivo')"
                    id="description"
                    cols="130"
                    rows="3"
                    v-model="occurrenceDescription"
                  ></textarea>
                </span>
                <button v-b-modal.faultTreeSelect class="reason-button">
                  {{ $t('motivo') }} </button>
              </div>

              <!-- Observação -->
              <div class="row-flex mt-3">
                <span class="row-flex">
                  <label class="label-desc mr-3">{{ $t('observacao') }} </label>
                  <textarea
                    name="ocurrenceObs"
                    :placeholder="$t('insira-uma-observacao')"
                    id="observation"
                    cols="117"
                    rows="3"
                    v-model="occurrenceObservation"
                  ></textarea>
                </span>
              </div>
              <!-- / Observação -->

              <div class="deadline-config mt-3">
                <div>
                  <label for="deadline"
                    >{{ $t('prazo-em-dias') }} <strong>{{ deadline }}</strong></label
                  >
                </div>
                <div class="ml-3">
                  <label for="deadline" title="$t('quantidade-de-registros-dentro-da-especificacao-0')">{{ $t('progressao') }}</label>
                  <input
                    @change="isGreaterThanNinety"
                    class="ml-2"
                    title="$t('quantidade-de-registros-dentro-da-especificacao-0')"
                    id="progression"
                    type="number"
                    name="progression"
                    v-model="progress"
                    min="1"
                    max="90"
                  />
                </div>

                <b-col sm="3" class="workOrderocurrence mt-3" v-if="enableWorkOrder">
                  <label for="workOrderocurrence" class="labelWorkOrderocurrence">{{$t('ordem-de-servico')}}:</label>
                  <span>
                    <input :title="$t('ordem-de-servico')" class="ml-2 input-pentagro" id="workOrderocurrence" type="text"
                      name="workOrderocurrence" v-model="workOrderOccurrence" />
                  </span>
                </b-col>
              </div>

              <!-- LISTA DE AÇÕES -->
              <ActionTable
                class="action-table"
                :editable="true"
                :newOccurrence="true"
                :responsibleList="responsibleList"
                :clean="cleanActions"
                :actionsProp.sync = actions
                :baseDate = productionDate
                :userEditor="true"
                @updateActionsList="updateActionsList($event)"
              ></ActionTable>
                <!-- / LISTA DE AÇÕES -->

              <div class="groupBtn mr-7">
                <img
                  src="@/assets/cancel.png"
                  :alt="$t('confirmar')"
                  style="margin-left: 20px;"
                  :title="$t('limpar-campos')"
                  v-b-modal.messageBox
                />

                <img
                  id="save-ocurrence-button"
                  class="ml-3"
                  @click="save"
                  src="../../assets/salvar.png"
                  :title="$t('criar-ocorrencia')"
                  alt="salvar_ocorrencia"
                />
              </div>
            </div>
          </div>
        </section>
        <!-- / CRIAR OCORRENCIAS -->

        <!-- OCORRENCIAS RELACIONADAS -->
        <section class="mt-3">
          <div class="row occurrences mt-3">
            <div
              class="col-12 table-responsive-md table-wrapper-scroll-y my-custom-scrollbar"
            >
              <p class="h6">{{ $t('ocorrencias-0') }}</p>
              <table class="table table-hover table-striped">
                <thead class="thead-dark">
                  <th scope="col">{{ $t('motivos') }}</th>
                  <th class="text-center" scope="col">{{ $t('data') }}</th>
                  <th class="text-center" scope="col">{{ $t('prazo') }}</th>
                </thead>
                <tbody>
                  <template v-if="this.indicatorOcurrences.length != 0">
                    <tr
                      v-for="(oc, index) in this.indicatorOcurrences"
                      :key="oc.id"
                      @click="onRowClick(index)"
                    >
                      <td>{{ oc.description }}</td>
                      <td class="text-center">
                        {{ oc.baseDate | occurrenceDate }}
                      </td>
                      <td class="text-center">
                        {{ (oc.deadline.includes("1900-01-01") ? "-" : oc.deadline) | occurrenceDate }}
                      </td>
                    </tr>
                  </template>
                </tbody>
              </table>
            </div>
          </div>
        </section>
        <!-- / OCORRENCIAS RELACIONADAS -->
      </span>
      <!-- / OCORRENCIAS -->
    </div>

    <b-modal
      id="faultTreeSelect"
      size="lg"
      hide-footer
      :title="$t('selecione-um-motivo')"
      :no-close-on-backdrop="true"
    >
      <FaultTreeSelect @result="applyReaseon"></FaultTreeSelect>

    </b-modal>

    <b-modal
      id="messageBox"
      size="md"
      hide-footer
      :title="$t('atention')"
      :no-close-on-backdrop="true"
    >
      <MessageBox
        :question="$t('confirmClearOccurrenceFields')"
        v-bind:action="confirmClearFieldsOccurrence"
        modelname="messageBox"
      />
    </b-modal>

    <b-modal
      id="confirmDuplicateOccurrence"
      size="md"
      hide-footer
      :title="$t('atention')"
      :no-close-on-backdrop="true"
    >
      <MessageBox
        :info="$t('confirmDuplicateOccurrenceMessage')"
        v-bind:action="confirmClearFieldsOccurrence"
        modelname="confirmDuplicateOccurrence"
      />
    </b-modal>

    <b-modal id="OccurrenceDetailsFT" size="xl" hide-footer>
      <div slot="modal-title" class="img-slot">
        <img
          style="width: 33px; height: 33px; margin-right: 10px;"
          src="@/assets/circular138.png"
          alt="salvar_ocorrencia"
        />
        {{ $t('editor-de-ocorrencia') }} </div>
      <OccurrenceDetails
        :nodeSelected="occurrenceSelected" 
        :loadTree="loadIndicatorOccurrences"
        nameForm="OccurrenceDetailsFT"
      ></OccurrenceDetails>
    </b-modal>
  </div>
</template>

<script>
import { urlMainAPI, showError, defaultSuccess } from "@/global";
import axios from "axios";
import * as moment from "moment";
import "moment/locale/pt-br";
import PageTitle from "@/components/template/PageTitle.vue";
import FaultTreeSelect from "../faultTreeSelect/FaultTreeSelect.vue";
import OccurrenceDetails from "@/components/occurrencetree/modal/OccurrenceDetails.vue";
import ActionTable from "./actionTable.vue";
import MessageBox from "@/components/template/MessageBoxModal.vue";
import { OccurrenceMixin } from "./occurrenceMixin"
import { FiltersMixin } from "../mixins/filtersMixin";
import { WaitMixin }  from "../mixins/waitMixin"

export default {
  components: {
    PageTitle,
    FaultTreeSelect,
    MessageBox,
    ActionTable,
    OccurrenceDetails
  },

  mixins: [ OccurrenceMixin, FiltersMixin, WaitMixin ],

  data: function() {
    return {
      system: "",
      productionUnit: null,
      occurrenceSelected: {},
      showForm: false,
      indicators: [],
      productionDate: null,
      occurrenceDescription: "",
      occurrenceObservation: "",
      responsibleList: [],
      responsible: null,
      responsibleId: -1,
      responsibleUnitId: null,
      occurrence: null,
      clearOccurrenceFields: 0,
      indicatorOcurrences: [],
      filter: "",
      actionEdit: {},
      biggerDate: "",
      clickedOnTable: false,
      loadingReport: false,
      workeOrder: "",
    };
  },
  filters: {
    occurrenceDate(date) {
      if(date == "-") return date;
      let occurenceDate = date.split(" ")[0];
      occurenceDate = occurenceDate.split("-").reverse();
      occurenceDate = occurenceDate.join("/");
      return occurenceDate;
    },
  },
  watch: {
    responsible: function(newVal) {
      if (newVal) {
        this.responsibleId = newVal.id;
        this.responsibleUnitId = newVal.unitId;
      } else {
        this.responsibleId = -1;
        this.responsibleKey = null
      }
    },

    productionDate() {
      this.showForm = false;
      this.indicatorId = null;
      this.indicatorOcurrences = [];
      let previousTr = document.querySelector(".indicator-selected");
      if (previousTr) previousTr.classList.remove("indicator-selected");
    },

    productionUnit() {
      this.showForm = false;
      this.indicatorId = null;
      this.indicatorOcurrences = [];
      let previousTr = document.querySelector(".indicator-selected");

      if (previousTr) previousTr.classList.remove("indicator-selected");
    },

    filter() {
      this.filteredIndicators = this.indicators.filter((indicator) => {
        const indicatorName = indicator.name.toUpperCase();
        const filter = this.filter.toUpperCase();
        if (indicatorName.includes(filter)) {
          return indicator;
        }
      });
    },

    occurrenceDescription(){
      this.setEnableWorker()
    },
  },

  methods: {
    async getWorOrderInOccurrence() {
      const url = `${urlMainAPI}/getsystemconfiguration`;
      await axios.get(url)
        .then((res) => {
          this.workeOrder = res.data.workOrderInOccurrence
        })
        .catch();
    },

    setEnableWorker(){
      if (this.occurrenceDescription.toLowerCase().includes("manutenção") && this.workeOrder)
        this.enableWorkOrder = true;
      else
        this.enableWorkOrder = false;
    },


    async save(){
      // Validações iniciais
      if (!this.indicatorId || this.indicatorId <= 0) {
        showError(this.$t('selecione-um-indicador-para-salvar-a-ocorrencia'));
        return;
      }

      if (!this.responsibleId || this.responsibleId === -1) {
        showError(this.$t('selecione-um-responsavel-para-salvar-a-ocorrencia'));
        return;
      }

      if (this.user.onlineType == 'PGDI' && !this.processId) {
        showError(this.$t('selecione-um-processo-1'));
        return;
      }

      if (!this.occurrenceDescription || this.occurrenceDescription.length == 0) {
        showError(this.$t('informe-um-motivo-para-a-ocorrencia'));
        return;
      }

      if (!this.actions || this.actions.length == 0) {
        showError(this.$t('adicione-ao-menos-uma-acao-para-a-ocorrencia'));
        return;
      }

      if (this.enableWorkOrder && !this.workOrderOccurrence) {
        showError(this.$t('campo-ordem-de-servico-e-obrigatorio'));
        return;
      }

      try {
        // Se passou nas validações, mostra mensagem de salvamento
        defaultSuccess(this.$t('salvando-ocorrencia'));
        this.waitOn();
        await this.saveOccurrence();
        await this.loadIndicatorOccurrences();
        await this.loadNonReliabilityIndicatorsList();
        this.waitOff();
      } catch (error) {
        this.waitOff();
        showError(this.$t('ocorrencia-salva-falha'));
      }
    },

    async loadIndicatorOccurrences() {
      let baseDate = this.formatBaseDate(this.productionDate);
      baseDate = baseDate + " 23:59:59";

      let getOccurrence = {
        id: this.indicatorId,
        baseDate: baseDate,
        productionUnitId: this.productionUnit.id,
        system: this.system,
      };

      const url = `${urlMainAPI}/getrelatedoccurrenceindicator`;
      this.waitOn();
      await axios.post(url, getOccurrence).then(res => {
        this.indicatorOcurrences = res.data;
        this.waitOff();
      }).catch(e => {
        console.log(e);
        this.waitOff();
      });
    },

    setSelectedIndicator(e) {
      const tr = e.target.parentNode;
      let indicatorId = "";

      indicatorId = tr.className.split("-")[1];

      let previousTr = document.querySelector(".indicator-selected");
      if (previousTr) previousTr.classList.remove("indicator-selected");

      tr.classList.add("indicator-selected");
      this.indicatorId = isNaN(Number(indicatorId)) ? this.indicatorId : Number(indicatorId);

      if (this.indicatorId >= 1) {
        defaultSuccess(this.$t('indicador-selecionado'));
        this.waitOn();
        this.cleanActions++;
        this.indicatorKey = this.loadIndicatorOccurrences();
        this.waitOff();
      }
    },

    async loadOccurrenceConfig() {
      if (!this.productionUnit) {
        showError(this.$t('selecione-uma-unidade-0'))
        return
      }
      this.indicators = []
      defaultSuccess(this.$t('carregando-dados-da-data-de-producao'))
      if (this.productionUnit) {
        this.loadingReport = true
        this.waitOn();
        await this.loadResponsibleList();
        await this.loadNonReliabilityIndicatorsList();
        this.waitOff();
        this.loadingReport = false
      }
      if (this.indicators.length > 0) {
        this.showForm = true;
      } else {
        this.showForm = false;
        this.indicatorId = null;
      }
    },

    async loadNonReliabilityIndicatorsList() {
      const url = `${urlMainAPI}/getnonreliabilityindicators/`;

      let baseDate = this.formatBaseDate(this.productionDate);
      baseDate = baseDate + " 23:59:59";
      const unitId = this.productionUnit.id;

      if (this.productionUnit != null) {
        await axios.post(url, { baseDate, unitId }).then((res) => {
          this.indicators = res.data.nonReliabilityIndicatorsList;
          if (this.indicators.length > 0) {
            this.indicators.sort(function(a, b) {
              return a.weight > b.weight ? -1 : a.weight < b.weight ? 0 : 1;
            });
            this.filteredIndicators = this.indicators;
            defaultSuccess(this.$t('indicadores-carregados-com-sucesso'));
          } else showError(this.$t('sem-dados-na-data-e-unidade-indicadas-0'));
        }).catch(e => console.log(e));
      }
    },

    confirmClearFieldsOccurrence() {
      this.eraseOccurrenceFieds();
    },

    eraseOccurrenceFieds() {
      this.occurrenceDescription = "";
      this.occurrenceObservation = "";
      this.responsibleId = -1;
      this.responsibleKey = null
      this.indicatorOcurrences = [];
      this.deadline = 0;
      this.progress = 1;
      this.cleanActions++
    },

    async getDeadLine()
    {
      let deadLine = "1900-01-01";


      await this.actions.forEach(a => {
        let date = this.formatBaseDate(a.date);
        let diff = moment(date, "YYYY-MM-DD").diff(moment(deadLine,"YYYY-MM-DD"))        
        if(diff > 0){
          deadLine = date;
        }
      })

      return deadLine  + " 23:59:59";
    },

    formatBaseDate(baseDate) {
      if (typeof baseDate == "object") {
        baseDate = baseDate.format().substring(0, 10);
      } else {
        baseDate = baseDate.split("/").reverse();
        baseDate = baseDate.join("-");
      }
      return baseDate;
    },

    onRowClick(index){
        if(this.clickedOnTable){
          let occurrence = this.indicatorOcurrences[index]
          console.log('occurrence :>> ', occurrence);
          if(occurrence){
            this.occurrenceSelected = { 
              id: occurrence.id,
              productionUnitId: occurrence.productionUnitId, 
              baseDate: occurrence.baseDate,
              system: occurrence.system
            }
            this.$bvModal.show("OccurrenceDetailsFT");
          }
        }
        else
        {    
          this.clickedOnTable = true;
          this.dbClickTimer()
        }
      },

      dbClickTimer(){ setTimeout(() => {this.clickedOnTable = false}, 400) },
  },

  created() {
    this.waitOff();
    this.system = this.$store.state.system == "GDI" ? "G" : "P";
    this.productionDate = moment().subtract(1, "day");
    this.getWorOrderInOccurrence();
  },

  destroyed() {
    this.waitOff();
  },
};
</script>

<style scoped src=".\occurrence.css"> </style>
